import { requestWithToken } from '../../utilities/request';
const path = '/api/private/fields';

/**
 * 現場情報の取得
 * @param {string}fieldId: 現場ID
 * */
const loadField = fieldId => {
  return requestWithToken({
    method: 'GET',
    url: path.concat(`/${fieldId}`),
  });
};

/**
 * 現場新規登録
 * @param {object}param
 * */
const registerField = param => {
  return requestWithToken({
    method: 'POST',
    url: path.concat(`/entry`),
    data: param,
    validateStatus(status) {
      // 400でメッセージを返すので 追加しないと本来ないはずのdataオブジェクトにレスポンスが入る
      return status === 400 || status === 200;
    },
  });
};

/**
 * 現場更新
 * @param {string}fieldId: 現場ID
 * @param {object}param
 * */
const updateField = (fieldId, param) => {
  return requestWithToken({
    method: 'PATCH',
    url: path.concat(`/${fieldId}`),
    data: param,
    validateStatus(status) {
      // 400でメッセージを返すので 追加しないと本来ないはずのdataオブジェクトにレスポンスが入る
      return status === 400 || status === 200;
    },
  });
};

/**
 * 現場承認状態更新
 * @param {string}fieldId: 現場ID
 * @param {object}param
 * */
const updateFieldApprovedStatus = (fieldId, param) => {
  return requestWithToken({
    method: 'PATCH',
    url: path.concat(`/${fieldId}/approval_update`),
    data: param,
  });
};

const deleteField = fieldId => {
  return requestWithToken({
    method: 'DELETE',
    url: path.concat(`/${fieldId}`),
  });
};

const checkForTurnOffWorkHourZoneFlag = (fieldId, params) => {
  return requestWithToken({
    method: 'GET',
    url: `${path}/${fieldId}/check_for_turn_off_work_hour_zone_flag`,
    params,
  });
};

export const FieldApi = {
  loadField,
  registerField,
  updateField,
  updateFieldApprovedStatus,
  deleteField,
  checkForTurnOffWorkHourZoneFlag,
};

export default FieldApi;



// WEBPACK FOOTER //
// ./src/services/field/FieldApi.js